import { RouteHandler } from '@whitetail/buckshot/scripts/buckshot-routes';
import $ from '@whitetail/buckshot/scripts/buckshot-dom';
import { active } from '../../scripts/classes';

class JoinSlider {
    constructor() {
        this.$slides = $(':slide');
        this.flickity = null;
        this.activeIndex = 0;
    }

    changeSlide(changeToIndex) {
        let nextSlide = changeToIndex;

        $(this.$slides[this.activeIndex]).removeClass(active);
        $(this.$slides[nextSlide]).addClass(active);

        this.activeIndex = nextSlide;

        if (this.activeIndex < this.$slides.length - 1) {
            nextSlide++;
        } else {
            nextSlide = 0;
        }

        window.setTimeout(() => { this.changeSlide(nextSlide); }, 2000);
    }
}

export default new RouteHandler({
    init() {
        new JoinSlider().changeSlide(0);
    },
});
